import React from 'react';
import { QuestionResponse } from '../../Types/QuestionResponse';

interface QuizProgressBarProps {
  questionAnswers: QuestionResponse[];
  currentQuestionAnswer: QuestionResponse;
}

const QuizProgressBar: React.FC<QuizProgressBarProps> = ({
  questionAnswers,
  currentQuestionAnswer,
}) => (
  <>
    {questionAnswers.map((questionAnswer, index) => (
      <div
        key={index}
        className={`flex flex-shrink min-w-0 flex-1 h-4 flex-col ${
          questionAnswer.answerState !== 'not answered' ||
          (currentQuestionAnswer != null &&
            currentQuestionAnswer.answerState !== 'not answered' &&
            currentQuestionAnswer.questionId === questionAnswer.questionId)
            ? 'bg-blue-500'
            : 'bg-gray-200'
        }`}
      />
    ))}
  </>
);

export default QuizProgressBar;
